import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ProjectSetup from "@/pages/ProjectSetup";
import ProjectHub from "@/pages/ProjectHub";
import MeetingWorkspace from "@/pages/MeetingWorkspace";
import SharePage from "@/pages/SharePage";
import Settings from "@/pages/Settings";
import Opportunities from "@/pages/Opportunities";
import OpportunityWorkspace from "@/pages/OpportunityWorkspace";
import AdminUsers from "@/pages/AdminUsers";
import InviteAccept from "@/pages/InviteAccept";
import SapConnectors from "@/pages/SapConnectors";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen grid place-items-center bg-background">
        <div className="animate-pulse text-muted-foreground text-sm">Loading Business360…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Google OAuth returns to /#session_id=... — handle before anything else.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/share/:token" element={<SharePage />} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Home />} />
        <Route path="/projects/new" element={<ProjectSetup />} />
        <Route path="/projects/:pid/edit" element={<ProjectSetup />} />
        <Route path="/projects/:pid" element={<ProjectHub />} />
        <Route path="/projects/:pid/meetings/:mid" element={<MeetingWorkspace />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/opportunities" element={<Opportunities />} />
        <Route path="/opportunities/:oid" element={<OpportunityWorkspace />} />
        <Route path="/connectors" element={<SapConnectors />} />
        <Route path="/admin" element={<AdminUsers />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
